import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import useDropdown from '../../modules/hooks/usedropdown';

const rootDialogStyle = {
  width: '720px',
  padding: '1em'
};

const buttonContainerStyle = {
  float: 'right'
};

const OnHoldDialog = ({
  isOpen,
  closeDialog,
  encounterId,
  holdReasons,
  doRedirect,
  submitHold
}) => {
  const [isCommentRequired, setIsCommentRequired] = useState();
  const [comment, setComment] = useState();
  const [dropdownState, dropdownApi] = useDropdown();

  useEffect(() => {
    if (holdReasons.length > 1) {
      setIsCommentRequired(holdReasons[1].payload);
      dropdownApi.setSelectedItem({
        target: { value: holdReasons[1].value },
        preventDefault: () => {},
        stopPropagation: () => {}
      });
    }
  }, [holdReasons.length]);

  const handleCommentChange = e => {
    setComment(e.target.value);
  };

  const setSelectedItem = e => {
    let payload = holdReasons.filter(el => {
      return el.value == e.target.value;
    })[0].payload;
    setIsCommentRequired(payload);
    dropdownApi.setSelectedItem(e);
  };

  const submitClick = () => {
    submitHold(encounterId, dropdownState.selectedItem, comment, doRedirect);
    closeDialog();
    setComment('');
  };

  const checkButtonDisabled = () => {
    if (dropdownState.selectedItem == '-1') return "disabled";

    if (isCommentRequired === false) return undefined;
    if (comment === '' || comment === undefined) return "disabled";
    return undefined;
  };

  const buttonDisabled = checkButtonDisabled();

  return (
    <Dialog
      open={isOpen}
      maxWidth="lg"
      disableBackdropClick
      disableEscapeKeyDown
    >
      <div style={rootDialogStyle}>
        <h4>Select a Hold Reason:</h4>
        <div>
          <select
            onChange={setSelectedItem}
            value={dropdownState.selectedItem}
          >
            {
              holdReasons.slice(1).map(x => (
                <option
                  key={x.value}
                  value={x.value}
                >
                  {x.label}
                </option>
              ))
            }
          </select>
        </div>
        <h4>Comment</h4>
        <textarea value={comment} onChange={handleCommentChange} cols="96" rows="8" maxLength="2500" />
        <div style={buttonContainerStyle}>
          <button onClick={submitClick} disabled={buttonDisabled}>
            Submit
          </button>
          <button onClick={closeDialog}>
            Cancel
          </button>
        </div>
      </div>
    </Dialog>
  );
};

OnHoldDialog.propTypes = {};

export default OnHoldDialog;
